import {styled as linariaStyled} from '@linaria/react';
import React, {FC} from 'react';
import sc, {css} from 'styled-components';
import {COLORS} from '../../../../../constants/colors';
import {tabletAndUp} from '../../../../../constants/customMedia';
import {overflowEllipsis} from '../../../../../constants/ellipsis';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../../../constants/typography';
import {Icon} from '../../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../../atoms/Icon/IconName';

interface USPReturnBadgeProps {
  badge?: {
    label: string;
    color: string;
  };
}

/**
 * @deprecated This component is deprecated because it violates best practices defined in the @aboutyou/ui-components.
 * Do not take inspiration from this component for new implementations.
 */
export const USPReturnBadge: FC<USPReturnBadgeProps> = ({badge}) => {
  if (!badge) {
    return null;
  }

  return (
    <USPReturnBadgeWrapper>
      <USPReturnIcon
        size={'XS'}
        asset={GenericIconName.USPReturn}
        data-testid={'uspReturnBadgeIcon'}
      />
      <Label>{badge.label}</Label>
    </USPReturnBadgeWrapper>
  );
};

const USPReturnBadgeWrapper = sc.div`
  display: flex;
  align-items: center;
  border-radius: 25px;
  padding: 0.125rem 0.5rem;
  margin-top: 0.5rem;
  height: 24px;
  background: ${COLORS.Grey4};

  ${tabletAndUp(
    css`
      padding: 0.25rem 0.375rem;
    `,
  )}
`;

const USPReturnIcon = linariaStyled(Icon)`
  fill: ${COLORS.Black};
  margin-right: 0.25rem;
`;

const Label = sc.span`
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  color: ${COLORS.Black};
  ${overflowEllipsis};
`;
